function getStore() {
  const s = require('../store').default
  return s
}

// 评估记录 mock 数据 — 与 employees 数据保持同步，含员工基本信息字段（反规范化存储，避免悬空引用）
export const evaluations = [
  {
    evaluation_id: 50001,
    employee_id: 10001,
    employee_name: '张三',
    employee_no: 'Z10001',
    dept_name: '运营中心',
    job_title: '运营总监',
    manager_email: '',
    evaluator_id: 1,
    evaluator_name: '张三（自评）',
    task_id: 1,
    task_name: '2024年度骨干人才保留',
    total_score: 25,
    risk_level: 3,
    risk_analysis: '该员工的离职风险主要源于"发展受限"（权重40%）和"外部机会"（权重35%），而非薪酬因素（5%）。',
    matched_behaviors: [
      { behavior_id: 103, description: '近3个月请假12次，较上季度增加300%', score: 8 },
      { behavior_id: 107, description: '当前薪资低于同职级中位数15%', score: 5 },
      { behavior_id: 112, description: '招聘平台活跃度监测显示，近30天更新简历2次，被猎头查看15次', score: 6 }
    ],
    matched_suggestions: [
      { title: '晋升通道梳理', content: '建议与HRBP沟通，明确未来6-12个月的晋升路径和关键里程碑。' },
      { title: '薪资竞争力分析', content: '建议发起薪资调研，确认同职级市场薪资水平，制定调薪方案。' }
    ],
    recommended_courses: [
      { title: '领导力进阶', content: '提升团队管理和跨部门协作能力。' }
    ],
    created_at: '2026-04-28 10:30:00'
  },
  {
    evaluation_id: 50002,
    employee_id: 10002,
    employee_name: '李四',
    employee_no: 'Z10002',
    dept_name: '技术中心',
    job_title: '高级开发工程师',
    manager_email: 'zhangsan@company.com',
    evaluator_id: 1,
    evaluator_name: '张三',
    task_id: 1,
    task_name: '2024年度骨干人才保留',
    total_score: 8,
    risk_level: 2,
    risk_analysis: '该员工的离职风险主要源于"工作压力"（权重50%），建议关注工作量平衡。',
    matched_behaviors: [
      { behavior_id: 105, description: '近1个月加班频次明显上升', score: 5 },
      { behavior_id: 108, description: '在团队会议上表现出疲惫情绪', score: 3 }
    ],
    matched_suggestions: [
      { title: '工作量评估', content: '建议评估当前项目排期，适当调整任务优先级。' }
    ],
    recommended_courses: [
      { title: '压力管理', content: '学习科学的情绪调节和时间管理方法。' }
    ],
    created_at: '2026-04-25 14:20:00'
  },
  {
    evaluation_id: 50003,
    employee_id: 10004,
    employee_name: '赵六',
    employee_no: 'Z10004',
    dept_name: '营销中心',
    job_title: '销售主管',
    manager_email: 'zhangsan@company.com',
    evaluator_id: 1,
    evaluator_name: '张三',
    task_id: 1,
    task_name: '2024年度骨干人才保留',
    total_score: 18,
    risk_level: 3,
    risk_analysis: '该员工的离职风险主要源于"团队氛围"（权重45%）和"发展空间"（权重40%）。',
    matched_behaviors: [
      { behavior_id: 110, description: '近2个月与直属上级沟通频次下降', score: 6 },
      { behavior_id: 115, description: '对团队活动参与度明显下降', score: 5 },
      { behavior_id: 117, description: '多次提及对当前岗位天花板的不满', score: 7 }
    ],
    matched_suggestions: [
      { title: '一对一沟通', content: '建议直属上级每周安排一次深度沟通，了解真实诉求。' },
      { title: '轮岗机会', content: '可探讨跨部门轮岗或新项目负责人的可能性。' }
    ],
    recommended_courses: [],
    created_at: '2026-04-22 09:15:00'
  },
  {
    evaluation_id: 50004,
    employee_id: 10010,
    employee_name: '陈十二',
    employee_no: 'Z10010',
    dept_name: '产品中心',
    job_title: 'UI设计师',
    manager_email: 'zhengshiyi@company.com',
    evaluator_id: 9,
    evaluator_name: '郑十一',
    task_id: 1,
    task_name: '2024年度骨干人才保留',
    total_score: 15,
    risk_level: 3,
    risk_analysis: '该员工的离职风险主要源于"创意限制"（权重50%）和"认可感不足"（权重30%）。',
    matched_behaviors: [
      { behavior_id: 112, description: '通过多个渠道发现其在招聘网站上更新简历、接触猎头', score: 6 },
      { behavior_id: 104, description: '负面情绪增多：态度消极，抱怨变多、效率下降、提"没意义"等话语', score: 5 },
      { behavior_id: 108, description: '职业诉求发生转变：想追求稳定（如考公）、工作生活平衡、转行新赛道', score: 4 }
    ],
    matched_suggestions: [
      { title: '设计自主权', content: '建议在非核心页面给予更多设计决策空间。' },
      { title: '认可机制', content: '建议建立设计作品定期展示和评审机制。' }
    ],
    recommended_courses: [
      { title: '设计思维进阶', content: '系统学习以用户为中心的设计方法论。' }
    ],
    created_at: '2026-04-20 16:45:00'
  },
  {
    evaluation_id: 50005,
    employee_id: 10007,
    employee_name: '周九',
    employee_no: 'Z10007',
    dept_name: '财务中心',
    job_title: '财务经理',
    manager_email: 'zhangsan@company.com',
    evaluator_id: 1,
    evaluator_name: '张三',
    task_id: 1,
    task_name: '2024年度骨干人才保留',
    total_score: 12,
    risk_level: 3,
    risk_analysis: '该员工的离职风险主要源于"职业倦怠"（权重55%）和"外部机会"（权重25%）。',
    matched_behaviors: [
      { behavior_id: 110, description: '"被忽视"或"无发展"：长期未获挑战性任务出现倦怠、绩效没达预期，晋升失败等', score: 5 },
      { behavior_id: 104, description: '负面情绪增多：态度消极，抱怨变多、效率下降、提"没意义""做不动了"等话语', score: 4 },
      { behavior_id: 108, description: '职业诉求发生转变：想追求稳定（如考公）、工作生活平衡、转行新赛道', score: 3 }
    ],
    matched_suggestions: [
      { title: '职业发展对话', content: '建议HRBP介入，探讨内部转岗或跨职能发展的可能性。' }
    ],
    recommended_courses: [],
    created_at: '2026-04-18 11:00:00'
  },
  {
    evaluation_id: 50006,
    employee_id: 10014,
    employee_name: '朱十六',
    employee_no: 'Z10014',
    dept_name: '技术中心',
    job_title: '架构师',
    manager_email: 'zhengshiyi@company.com',
    evaluator_id: 9,
    evaluator_name: '郑十一',
    task_id: 2,
    task_name: '2025春季专项评估',
    total_score: 20,
    risk_level: 3,
    risk_analysis: '该员工的离职风险主要源于"技术天花板"（权重60%）和"管理意愿冲突"（权重30%）。',
    matched_behaviors: [
      { behavior_id: 112, description: '通过多个渠道发现其在招聘网站上更新简历、接触猎头', score: 6 },
      { behavior_id: 110, description: '"被忽视"或"无发展"：长期未获挑战性任务出现倦怠、绩效没达预期，晋升失败等', score: 7 },
      { behavior_id: 108, description: '职业诉求发生转变：想追求稳定（如考公）、工作生活平衡、转行新赛道', score: 7 }
    ],
    matched_suggestions: [
      { title: '技术专家路径', content: '明确技术专家晋升通道，对标外部技术专家职级体系。' },
      { title: '技术大会机会', content: '提供行业技术大会分享和赞助机会。' }
    ],
    recommended_courses: [
      { title: '技术架构演进', content: '深入理解云原生和AI驱动的架构变革。' }
    ],
    created_at: '2026-04-15 09:30:00'
  },
  {
    evaluation_id: 50007,
    employee_id: 10017,
    employee_name: '罗十九',
    employee_no: 'Z10017',
    dept_name: '营销中心',
    job_title: '品牌经理',
    manager_email: 'zhengshiyi@company.com',
    evaluator_id: 9,
    evaluator_name: '郑十一',
    task_id: 2,
    task_name: '2025春季专项评估',
    total_score: 16,
    risk_level: 3,
    risk_analysis: '该员工的离职风险主要源于"品牌预算削减"（权重50%）和"市场认可度"（权重35%）。',
    matched_behaviors: [
      { behavior_id: 104, description: '负面情绪增多：态度消极，抱怨变多、效率下降、提"没意义"等话语', score: 7 },
      { behavior_id: 112, description: '通过多个渠道发现其在招聘网站上更新简历、接触猎头', score: 5 },
      { behavior_id: 108, description: '职业诉求发生转变：想追求稳定（如考公）、工作生活平衡、转行新赛道', score: 4 }
    ],
    matched_suggestions: [
      { title: '预算重新评估', content: '建议与财务沟通，争取核心品牌项目的预算保留。' },
      { title: '个人品牌保护', content: '探讨公司与个人品牌的双赢合作模式。' }
    ],
    recommended_courses: [],
    created_at: '2026-04-12 14:00:00'
  },
  {
    evaluation_id: 50008,
    employee_id: 10019,
    employee_name: '马二一',
    employee_no: 'Z10019',
    dept_name: '运营中心',
    job_title: '内容运营',
    manager_email: 'zhengshiyi@company.com',
    evaluator_id: 9,
    evaluator_name: '郑十一',
    task_id: 2,
    task_name: '2025春季专项评估',
    total_score: 10,
    risk_level: 2,
    risk_analysis: '该员工的离职风险主要源于"内容方向调整"（权重55%）和"绩效压力"（权重30%）。',
    matched_behaviors: [
      { behavior_id: 104, description: '负面情绪增多：态度消极，抱怨变多、效率下降、提"没意义"等话语', score: 5 },
      { behavior_id: 103, description: '工作节奏改变：频繁早退/请假、回避额外责任，不愿参与团建', score: 3 },
      { behavior_id: 112, description: '通过多个渠道发现其在招聘网站上更新简历、接触猎头', score: 2 }
    ],
    matched_suggestions: [
      { title: '风格对齐', content: '安排创意总监一对一辅导，帮助理解新方向。' },
      { title: '绩效调整', content: '重新评估绩效指标的合理性，设置过渡期。' }
    ],
    recommended_courses: [
      { title: '内容运营进阶', content: '学习数据驱动的内容创作方法论。' }
    ],
    created_at: '2026-04-10 10:30:00'
  },
  // ===== 任务3：2026年度骨干人才保留评估记录 =====
  // --- 王志远历史评估记录（高风险持续上升）---
  {
    evaluation_id: 50018,
    employee_id: 10021,
    employee_name: '王志远',
    employee_no: 'Z10021',
    dept_name: '技术中心',
    job_title: '技术总监',
    manager_email: '',
    evaluator_id: 1,
    evaluator_name: '王志远（自评）',
    task_id: 3,
    task_name: '2026年度骨干人才保留',
    total_score: 12,
    risk_level: 3,
    risk_analysis: '初步观察到管理压力增加，团队沟通频次有所下降。',
    matched_behaviors: [
      { behavior_id: 110, description: '"被忽视"或"无发展"：长期未获挑战性任务出现倦怠、绩效没达预期，晋升失败等', score: 6 },
      { behavior_id: 104, description: '负面情绪增多：态度消极，抱怨变多、效率下降、提"没意义"等话语', score: 4 },
      { behavior_id: 201, description: '任务1-特需关注：项目交付延期且未主动同步', score: 2 }
    ],
    matched_suggestions: [
      { title: '管理减负', content: '适当下放部分管理事务，聚焦技术战略和团队建设。' }
    ],
    recommended_courses: [],
    created_at: '2026-01-08 10:00:00'
  },
  {
    evaluation_id: 50019,
    employee_id: 10021,
    employee_name: '王志远',
    employee_no: 'Z10021',
    dept_name: '技术中心',
    job_title: '技术总监',
    manager_email: '',
    evaluator_id: 1,
    evaluator_name: '王志远（自评）',
    task_id: 3,
    task_name: '2026年度骨干人才保留',
    total_score: 15,
    risk_level: 3,
    risk_analysis: '管理倦怠感加重，技术参与度持续降低。',
    matched_behaviors: [
      { behavior_id: 110, description: '"被忽视"或"无发展"：长期未获挑战性任务出现倦怠、绩效没达预期，晋升失败等', score: 7 },
      { behavior_id: 104, description: '负面情绪增多：态度消极，抱怨变多、效率下降、提"没意义"等话语', score: 5 },
      { behavior_id: 201, description: '任务1-特需关注：项目交付延期且未主动同步', score: 3 }
    ],
    matched_suggestions: [
      { title: '技术复耕计划', content: '安排参与核心代码评审和技术方案设计，重建技术存在感。' }
    ],
    recommended_courses: [],
    created_at: '2026-02-10 14:00:00'
  },
  {
    evaluation_id: 50020,
    employee_id: 10021,
    employee_name: '王志远',
    employee_no: 'Z10021',
    dept_name: '技术中心',
    job_title: '技术总监',
    manager_email: '',
    evaluator_id: 1,
    evaluator_name: '王志远（自评）',
    task_id: 3,
    task_name: '2026年度骨干人才保留',
    total_score: 18,
    risk_level: 3,
    risk_analysis: '技术脱节焦虑明显，多次提及对新技术栈的陌生感。',
    matched_behaviors: [
      { behavior_id: 110, description: '"被忽视"或"无发展"：长期未获挑战性任务出现倦怠、绩效没达预期，晋升失败等', score: 7 },
      { behavior_id: 104, description: '负面情绪增多：态度消极，抱怨变多、效率下降、提"没意义"等话语', score: 6 },
      { behavior_id: 201, description: '任务1-特需关注：项目交付延期且未主动同步', score: 5 }
    ],
    matched_suggestions: [
      { title: '外部技术交流', content: '安排参加行业技术大会和闭门研讨会，拓展技术视野。' }
    ],
    recommended_courses: [
      { title: 'AI驱动架构', content: '学习大模型时代的系统架构设计新范式。' }
    ],
    created_at: '2026-03-15 09:30:00'
  },
  {
    evaluation_id: 50021,
    employee_id: 10021,
    employee_name: '王志远',
    employee_no: 'Z10021',
    dept_name: '技术中心',
    job_title: '技术总监',
    manager_email: '',
    evaluator_id: 1,
    evaluator_name: '王志远（自评）',
    task_id: 3,
    task_name: '2026年度骨干人才保留',
    total_score: 20,
    risk_level: 3,
    risk_analysis: '管理倦怠与技术脱节双重压力，离职风险持续攀升。',
    matched_behaviors: [
      { behavior_id: 201, description: '任务1-特需关注：项目交付延期且未主动同步', score: 7 },
      { behavior_id: 104, description: '负面情绪增多：态度消极，抱怨变多、效率下降、提"没意义"等话语', score: 6 },
      { behavior_id: 110, description: '"被忽视"或"无发展"：长期未获挑战性任务出现倦怠、绩效没达预期，晋升失败等', score: 7 }
    ],
    matched_suggestions: [
      { title: '管理顾问支持', content: '引入外部管理顾问，协助优化团队管理流程。' }
    ],
    recommended_courses: [],
    created_at: '2026-04-12 11:00:00'
  },
  {
    evaluation_id: 50009,
    employee_id: 10021,
    employee_name: '王志远',
    employee_no: 'Z10021',
    dept_name: '技术中心',
    job_title: '技术总监',
    manager_email: '',
    evaluator_id: 1,
    evaluator_name: '王志远（自评）',
    task_id: 3,
    task_name: '2026年度骨干人才保留',
    total_score: 22,
    risk_level: 3,
    risk_analysis: '该员工的离职风险主要源于"管理倦怠"（权重45%）和"技术脱节焦虑"（权重35%）。',
    matched_behaviors: [
      { behavior_id: 201, description: '任务1-特需关注：项目交付延期且未主动同步', score: 8 },
      { behavior_id: 104, description: '负面情绪增多：态度消极，抱怨变多、效率下降、提"没意义"等话语', score: 7 },
      { behavior_id: 110, description: '"被忽视"或"无发展"：长期未获挑战性任务出现倦怠、绩效没达预期，晋升失败等', score: 7 }
    ],
    matched_suggestions: [
      { title: '技术管理双轨制', content: '探讨技术管理双轨发展路径，保留技术影响力的同时兼顾管理职责。' },
      { title: '技术大会参与', content: '提供行业技术大会演讲和评审机会，维持外部技术影响力。' }
    ],
    recommended_courses: [
      { title: '技术领导力', content: '学习如何在管理角色中保持技术敏锐度和影响力。' }
    ],
    created_at: '2026-05-15 09:00:00'
  },
  {
    evaluation_id: 50010,
    employee_id: 10022,
    employee_name: '陈晓东',
    employee_no: 'Z10022',
    dept_name: '技术中心',
    job_title: '高级后端工程师',
    manager_email: 'wangzhiyuan@company.com',
    evaluator_id: 21,
    evaluator_name: '王志远',
    task_id: 3,
    task_name: '2026年度骨干人才保留',
    total_score: 15,
    risk_level: 3,
    risk_analysis: '该员工的离职风险主要源于"外部机会活跃"（权重100%），建议立即关注招聘平台动态并安排保留面谈。',
    matched_behaviors: [
      { behavior_id: 112, description: '通过多个渠道发现其在招聘网站上更新简历、接触猎头', score: 15 }
    ],
    answers: {112: 1},
    matched_suggestions: [
      { title: '挑战性任务分配', content: '安排参与核心架构改造或新技术调研项目。' },
      { title: '技术分享机会', content: '组织内部技术分享，给予技术影响力建设平台。' }
    ],
    recommended_courses: [
      { title: '分布式系统设计', content: '深入学习高并发系统架构设计方法论。' }
    ],
    created_at: '2026-05-12 14:30:00'
  },
  // ===== 林晓峰历史评估记录（展示趋势变化）=====
  {
    evaluation_id: 50014,
    employee_id: 10023,
    employee_name: '林晓峰',
    employee_no: 'Z10023',
    dept_name: '产品中心',
    job_title: '产品经理',
    manager_email: 'wangzhiyuan@company.com',
    evaluator_id: 21,
    evaluator_name: '王志远',
    task_id: 3,
    task_name: '2026年度骨干人才保留',
    total_score: 2,
    risk_level: 1,
    risk_analysis: '该员工目前离职风险较低，工作状态稳定。',
    matched_behaviors: [
      { behavior_id: 116, description: '上班太远，花费太多时间', score: 1 },
      { behavior_id: 101, description: '投入度明显下降：从主动推进变为被动执行，需反复催促', score: 1 }
    ],
    answers: {116: 1, 101: 1},
    matched_suggestions: [
      { title: '保持现状', content: '继续保持良好的团队氛围和沟通机制。' }
    ],
    recommended_courses: [],
    created_at: '2026-01-10 10:00:00'
  },
  {
    evaluation_id: 50015,
    employee_id: 10023,
    employee_name: '林晓峰',
    employee_no: 'Z10023',
    dept_name: '产品中心',
    job_title: '产品经理',
    manager_email: 'wangzhiyuan@company.com',
    evaluator_id: 21,
    evaluator_name: '王志远',
    task_id: 3,
    task_name: '2026年度骨干人才保留',
    total_score: 3,
    risk_level: 1,
    risk_analysis: '该员工目前离职风险较低，仅观察到轻微的工作节奏变化。',
    matched_behaviors: [
      { behavior_id: 116, description: '上班太远，花费太多时间', score: 1 },
      { behavior_id: 103, description: '工作节奏改变：频繁早退/请假、回避额外责任，不愿参与团建', score: 2 }
    ],
    answers: {116: 1, 103: 1},
    matched_suggestions: [
      { title: '灵活办公', content: '可考虑每周1-2天远程办公，减少通勤压力。' }
    ],
    recommended_courses: [],
    created_at: '2026-02-08 14:30:00'
  },
  {
    evaluation_id: 50016,
    employee_id: 10023,
    employee_name: '林晓峰',
    employee_no: 'Z10023',
    dept_name: '产品中心',
    job_title: '产品经理',
    manager_email: 'wangzhiyuan@company.com',
    evaluator_id: 21,
    evaluator_name: '王志远',
    task_id: 3,
    task_name: '2026年度骨干人才保留',
    total_score: 4,
    risk_level: 1,
    risk_analysis: '该员工离职风险仍处于低位，但工作投入度有轻微下降趋势。',
    matched_behaviors: [
      { behavior_id: 103, description: '工作节奏改变：频繁早退/请假、回避额外责任，不愿参与团建', score: 3 },
      { behavior_id: 116, description: '上班太远，花费太多时间', score: 1 }
    ],
    answers: {103: 1, 116: 1},
    matched_suggestions: [
      { title: '工作量评估', content: '评估当前项目排期，适当调整任务优先级。' }
    ],
    recommended_courses: [],
    created_at: '2026-03-12 09:00:00'
  },
  {
    evaluation_id: 50017,
    employee_id: 10023,
    employee_name: '林晓峰',
    employee_no: 'Z10023',
    dept_name: '产品中心',
    job_title: '产品经理',
    manager_email: 'wangzhiyuan@company.com',
    evaluator_id: 21,
    evaluator_name: '王志远',
    task_id: 3,
    task_name: '2026年度骨干人才保留',
    total_score: 5,
    risk_level: 2,
    risk_analysis: '该员工离职风险进入中风险区间，负面情绪和工作节奏变化值得注意。',
    matched_behaviors: [
      { behavior_id: 103, description: '工作节奏改变：频繁早退/请假、回避额外责任，不愿参与团建', score: 3 },
      { behavior_id: 104, description: '负面情绪增多：态度消极，抱怨变多、效率下降、提"没意义"等话语', score: 2 }
    ],
    answers: {103: 1, 104: 1},
    matched_suggestions: [
      { title: '一对一沟通', content: '建议直属上级安排深度沟通，了解真实诉求。' }
    ],
    recommended_courses: [],
    created_at: '2026-04-15 16:00:00'
  },
  {
    evaluation_id: 50011,
    employee_id: 10023,
    employee_name: '林晓峰',
    employee_no: 'Z10023',
    dept_name: '产品中心',
    job_title: '产品经理',
    manager_email: 'wangzhiyuan@company.com',
    evaluator_id: 21,
    evaluator_name: '王志远',
    task_id: 3,
    task_name: '2026年度骨干人才保留',
    total_score: 7,
    risk_level: 2,
    risk_analysis: '该员工的离职风险主要源于"工作节奏改变"（权重43%）和"负面情绪增多"（权重43%）。',
    matched_behaviors: [
      { behavior_id: 103, description: '工作节奏改变：频繁早退/请假、回避额外责任，不愿参与团建', score: 3 },
      { behavior_id: 104, description: '负面情绪增多：态度消极，抱怨变多、效率下降、提"没意义"等话语', score: 3 },
      { behavior_id: 116, description: '上班太远，花费太多时间', score: 1 }
    ],
    answers: {103: 1, 104: 1, 116: 1},
    matched_suggestions: [
      { title: '工作量评估', content: '评估当前项目排期，适当调整任务优先级。' }
    ],
    recommended_courses: [],
    created_at: '2026-05-08 11:00:00'
  },
  // --- 张婷婷历史评估记录（低风险稳定）---
  {
    evaluation_id: 50022,
    employee_id: 10024,
    employee_name: '张婷婷',
    employee_no: 'Z10024',
    dept_name: '运营中心',
    job_title: '运营主管',
    manager_email: 'wangzhiyuan@company.com',
    evaluator_id: 21,
    evaluator_name: '王志远',
    task_id: 3,
    task_name: '2026年度骨干人才保留',
    total_score: 1,
    risk_level: 1,
    risk_analysis: '该员工工作状态良好，未发现明显离职风险信号。',
    matched_behaviors: [
      { behavior_id: 116, description: '上班太远，花费太多时间', score: 1 }
    ],
    answers: {116: 1},
    matched_suggestions: [
      { title: '保持现状', content: '继续保持良好的团队氛围和沟通机制。' }
    ],
    recommended_courses: [],
    created_at: '2026-03-10 10:00:00'
  },
  {
    evaluation_id: 50023,
    employee_id: 10024,
    employee_name: '张婷婷',
    employee_no: 'Z10024',
    dept_name: '运营中心',
    job_title: '运营主管',
    manager_email: 'wangzhiyuan@company.com',
    evaluator_id: 21,
    evaluator_name: '王志远',
    task_id: 3,
    task_name: '2026年度骨干人才保留',
    total_score: 2,
    risk_level: 1,
    risk_analysis: '该员工目前离职风险较低，工作状态整体稳定。',
    matched_behaviors: [
      { behavior_id: 116, description: '上班太远，花费太多时间', score: 1 },
      { behavior_id: 101, description: '投入度明显下降：从主动推进变为被动执行，需反复催促', score: 1 }
    ],
    answers: {116: 1, 101: 1},
    matched_suggestions: [
      { title: '保持现状', content: '继续保持良好的团队氛围和沟通机制。' }
    ],
    recommended_courses: [],
    created_at: '2026-04-08 14:00:00'
  },
  {
    evaluation_id: 50012,
    employee_id: 10024,
    employee_name: '张婷婷',
    employee_no: 'Z10024',
    dept_name: '运营中心',
    job_title: '运营主管',
    manager_email: 'wangzhiyuan@company.com',
    evaluator_id: 21,
    evaluator_name: '王志远',
    task_id: 3,
    task_name: '2026年度骨干人才保留',
    total_score: 3,
    risk_level: 1,
    risk_analysis: '该员工目前离职风险较低，仅观察到轻微的工作投入度波动，建议持续关注即可。',
    matched_behaviors: [
      { behavior_id: 101, description: '投入度明显下降：从主动推进变为被动执行，需反复催促', score: 2 },
      { behavior_id: 116, description: '上班太远，花费太多时间', score: 1 }
    ],
    answers: {101: 1, 116: 1},
    matched_suggestions: [
      { title: '保持现状', content: '继续保持良好的团队氛围和沟通机制。' }
    ],
    recommended_courses: [],
    created_at: '2026-05-05 16:00:00'
  },
  // 离职员工-已评估
  {
    evaluation_id: 50013,
    employee_id: 20004,
    employee_name: '孙浩然',
    employee_no: 'Z20004',
    dept_name: '技术中心',
    job_title: '前端工程师',
    manager_email: 'wangzhiyuan@company.com',
    evaluator_id: 21,
    evaluator_name: '王志远',
    task_id: 3,
    task_name: '2026年度骨干人才保留',
    total_score: 19,
    risk_level: 3,
    risk_analysis: '该员工在离职前评估显示高风险，主要源于"薪酬竞争力不足"（权重50%）和"技术成长受限"（权重35%）。',
    matched_behaviors: [
      { behavior_id: 112, description: '通过多个渠道发现其在招聘网站上更新简历、接触猎头', score: 7 },
      { behavior_id: 104, description: '负面情绪增多：态度消极，抱怨变多、效率下降、提"没意义"等话语', score: 5 },
      { behavior_id: 107, description: '薪资相对同职级明显偏低，甚至倒挂严重；长期未涨薪', score: 7 }
    ],
    matched_suggestions: [
      { title: '紧急保留面谈', content: '建议48小时内安排保留面谈，了解具体外部offer条件。' },
      { title: '薪酬对标调整', content: '启动紧急薪酬调整流程，缩小与市场水平差距。' }
    ],
    recommended_courses: [],
    created_at: '2026-04-20 10:00:00'
  }
]

export const trendData = {
  10001: [
    { month: '2025-05', score: 2 }, { month: '2025-06', score: 3 }, { month: '2025-07', score: 5 },
    { month: '2025-08', score: 4 }, { month: '2025-09', score: 8 }, { month: '2025-10', score: 12 },
    { month: '2025-11', score: 10 }, { month: '2025-12', score: 15 }, { month: '2026-01', score: 18 },
    { month: '2026-02', score: 20 }, { month: '2026-03', score: 22 }, { month: '2026-04', score: 25 }
  ],
  10002: [
    { month: '2025-05', score: 0 }, { month: '2025-06', score: 1 }, { month: '2025-07', score: 2 },
    { month: '2025-08', score: 3 }, { month: '2025-09', score: 2 }, { month: '2025-10', score: 4 },
    { month: '2025-11', score: 5 }, { month: '2025-12', score: 6 }, { month: '2026-01', score: 7 },
    { month: '2026-02', score: 6 }, { month: '2026-03', score: 8 }, { month: '2026-04', score: 8 }
  ],
  10004: [
    { month: '2025-05', score: 5 }, { month: '2025-06', score: 8 }, { month: '2025-07', score: 10 },
    { month: '2025-08', score: 12 }, { month: '2025-09', score: 11 }, { month: '2025-10', score: 14 },
    { month: '2025-11', score: 15 }, { month: '2025-12', score: 16 }, { month: '2026-01', score: 17 },
    { month: '2026-02', score: 16 }, { month: '2026-03', score: 17 }, { month: '2026-04', score: 18 }
  ],
  // 任务3趋势数据
  10021: [
    { month: '2025-08', score: 5 }, { month: '2025-09', score: 8 }, { month: '2025-10', score: 10 },
    { month: '2025-11', score: 12 }, { month: '2025-12', score: 14 }, { month: '2026-01', score: 16 },
    { month: '2026-02', score: 18 }, { month: '2026-03', score: 20 }, { month: '2026-04', score: 21 },
    { month: '2026-05', score: 22 }
  ],
  10022: [
    { month: '2025-10', score: 2 }, { month: '2025-11', score: 4 }, { month: '2025-12', score: 6 },
    { month: '2026-01', score: 8 }, { month: '2026-02', score: 10 }, { month: '2026-03', score: 12 },
    { month: '2026-04', score: 14 }, { month: '2026-05', score: 15 }
  ],
  10023: [
    { month: '2025-11', score: 1 }, { month: '2025-12', score: 2 }, { month: '2026-01', score: 3 },
    { month: '2026-02', score: 4 }, { month: '2026-03', score: 5 }, { month: '2026-04', score: 6 },
    { month: '2026-05', score: 7 }
  ],
  10024: [
    { month: '2026-01', score: 1 }, { month: '2026-02', score: 2 }, { month: '2026-03', score: 2 },
    { month: '2026-04', score: 3 }, { month: '2026-05', score: 3 }
  ],
  20004: [
    { month: '2025-09', score: 3 }, { month: '2025-10', score: 6 }, { month: '2025-11', score: 9 },
    { month: '2025-12', score: 12 }, { month: '2026-01', score: 14 }, { month: '2026-02', score: 16 },
    { month: '2026-03', score: 17 }, { month: '2026-04', score: 19 }
  ]
}

export function getThresholds() {
  const s = getStore()
  return s.state.settings && s.state.settings.settings && s.state.settings.settings.thresholds
    ? s.state.settings.settings.thresholds
    : { lowMax: 4, mediumMax: 10 }
}
